import {
  getLearningApiClientFunctions,
  ILearning,
} from "@kunduz/data-access-learning-api";
import {
  getLearningCachedCourses,
  getLearningCachedExams,
  getLearningCachedGrades,
} from "../../domains/learning/services/cachedLearningFilterMenuItems";
import { GetServerSideProps } from "next";
import { getSelectorsByUserAgent } from "react-device-detect";
import GoalPage, {
  GoalPageProps,
} from "../../domains/learning/pages/goalPage/goalPage";
import { serverSideTranslations } from "../../common/utility/serverSideTranslations";
import { ReservedWords } from "@kunduz/utility-common";
import { getCachedHeaderItems } from "../../common/services/cachedHeaderItems";
import { getCachedHeaderBanner } from "../../common/services/cachedHeaderBanner";

export default function SinavPage(props: GoalPageProps) {
  return (
    <GoalPage
      isMobile={props.isMobile}
      lang={props.lang}
      isAuth={props.isAuth}
      currentPage={props.currentPage}
      filterItems={props.filterItems}
      pageMeta={props.pageMeta}
      pathItems={props.pathItems}
      perPage={props.perPage}
      type={props.type}
      headerItems={props.headerItems}
      headerBanner={props.headerBanner}
    />
  );
}

export const getServerSideProps: GetServerSideProps = async ({
  req,
  res,
  query,
}) => {
  const { isMobile } = getSelectorsByUserAgent(req.headers["user-agent"]);
  const lang = "tr";
  const { kz_user_token } = req.cookies;

  const page = Number((query.page as string) || "1");
  const perPage = 12;

  const learningApiClientFunctions = getLearningApiClientFunctions();
  const headerItems = await getCachedHeaderItems(lang, "student");
  const headerBanner = await getCachedHeaderBanner("tr");

  const [coursesResult, examsResult, gradesResult, pathItemsResult, pageMeta] =
    await Promise.allSettled([
      getLearningCachedCourses(lang),
      getLearningCachedExams(lang),
      getLearningCachedGrades(lang),
      learningApiClientFunctions.getLearningPathItems({
        slug: query.pathListSlug as string,
        page,
        size: perPage,
      }),
      learningApiClientFunctions.getContentBySlug<ILearning.PathListResponse>(
        "exams",
        query.pathListSlug as string,
        {
          page,
          size: perPage,
        },
      ),
    ]);

  if (
    coursesResult.status === "rejected" ||
    examsResult.status === "rejected" ||
    gradesResult.status === "rejected" ||
    pathItemsResult.status === "rejected" ||
    pageMeta.status === "rejected" ||
    !coursesResult.value ||
    !examsResult.value ||
    !gradesResult.value ||
    !pathItemsResult.value ||
    !pageMeta.value
  ) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      isMobile,
      isAuth: !!kz_user_token,
      lang,
      filterItems: {
        courses: coursesResult.value,
        exams: examsResult.value,
        grades: gradesResult.value,
      },
      pathItems: pathItemsResult.value,
      currentPage: page,
      perPage,
      pageMeta: pageMeta.value,
      type: ReservedWords.TR_CONTENT_EXAM,
      headerItems,
      headerBanner,
      ...(await serverSideTranslations(lang, [
        "questionIndexing",
        "kunduzcom_learning",
        "kunduzcom_common",
      ])),
    },
  };
};
